import styled from 'styled-components';
import { TABLET_WIDTH } from '~~elements/Const';
import DefaultAvatar from '~~elements/static/DefaultAvatar.jpg';
import BackSVG from './assets/chevron-left.svg';

export const finishedGameBGColor = '#eaeaea';
export const playingGameBGColor = '#b1e765';
export const finishedCriticalGameBGColor = '#fcc3bd';
export const finishedMissingGameBGColor = '#fcee9a';

export const winnerTeamColor = '#14c206';
export const loserTeamColor = '#8f8f8f';

export const SectionDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  letter-spacing: 1px;
  padding-top: 2rem;
`;

export const StyledForm = styled.form`
  display: flex;
  align-items: start;
  justify-content: space-between;
  width: 100%;

  .icon {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &--pic {
      border-radius: 50%;
      width: 8rem;
      height: 8rem;
      display: block;
      margin-bottom: 0.5rem;
      object-fit: cover;
      &.default {
        background-image: url(${DefaultAvatar});
        background-size: cover;
        background-position: center;
      }
    }
    &--box {
      display: flex;
      justify-content: center;
    }
  }

  .cover {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    &--box {
      display: flex;
      justify-content: start;
    }
    &--pic {
      position: relative;
      z-index: 2;
      width: 80%;
      text-align: start;
      &:after {
        content: '';
        display: block;
        padding-bottom: 75%;
      }
      > img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.default {
        background-image: url(${DefaultAvatar});
        background-size: cover;
        background-position: center;
      }
    }
  }

  .box {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;

    label {
      display: block;
      > i {
        color: red;
        font-size: 0.8rem;
      }
    }
    .input-field {
      width: 80%;
      display: flex;
      align-items: center;
      margin-bottom: 2rem;
      font-size: 1rem;
      > div {
        margin-right: 0.5rem;
      }
      .input-box {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        input:not(:first-child) {
          margin-left: 0.5rem;
        }
      }
      .input-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        > * {
          margin: 0 0.5rem 0.2rem 0;
          display: flex;
          align-items: center;
          white-space: nowrap;
        }
        .remove-icon-wrapper {
          padding: 0.2rem 0.3rem 0.2rem 0.2rem;
          background-color: rgb(10, 74, 154, 0.1);
          border-radius: 5px;
        }
      }
    }

    .error-msg {
      font-size: 0.8rem;
      color: #e8196e;
    }

    .success-msg {
      font-size: 0.8rem;
      color: green;
    }
  }

  .divider {
    border: 1px #222 solid;
    width: 100%;
    height: 0px;
  }

  input[type='checkbox'] {
    margin: 0 0.1rem;
  }

  @media (max-width: ${TABLET_WIDTH}) {
    flex-direction: column-reverse;
    .icon {
      width: 100%;
    }
    .cover {
      justify-content: center;
      align-items: center;
    }
    .box {
      width: 90%;
      .input-field {
        width: 100%;
        &.--multi-input {
          align-items: flex-start;
          flex-wrap: wrap;
        }
        .input-box {
          flex-direction: column;
          input:not(:first-child) {
            margin-left: 0;
            margin-top: 5%;
          }
        }
      }
    }
  }
`;

export const SchedulePanelDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  .schedule-panel {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &--start {
      justify-content: flex-start;
      > * {
        margin-right: 0.5rem;
      }
    }
    &--end {
      justify-content: flex-end;
      > * {
        margin-left: 0.5rem;
      }
    }
  }

  .pre-next-control {
    width: 2rem;
    height: 2rem;
    padding: 0;
    border-radius: 50%;
    border: none;
    &:hover {
      box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
    }
    > img {
      padding: 0;
      margin: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const ListModeDiv = styled.div`
  width: 100%;
  overflow-x: auto;
  .list-mode {
    width: 100%;
    min-width: 35rem;
  }

  .list-mode-item {
    text-align: start;
    border-bottom: 1px solid #eee;
    &--name {
      display: block;
      > button {
        margin-left: 1rem;
      }
      margin: 0;
      padding: 0.5rem 0;
    }
    &--games {
      width: 100%;
      min-height: 2rem;
      max-height: 25rem;
      overflow-y: auto;
      ::-webkit-scrollbar {
        width: 2px;
      }
    }
    &--game {
      display: grid;
      grid-template-columns: 2fr 3fr 2fr;
      border: 1px solid #eee;
      border-radius: 10px;
      margin: 0.1rem 0;

      cursor: pointer;
      label {
        cursor: pointer;
      }

      &.finished {
        background-color: ${finishedGameBGColor};
        &.CRITICAL {
          background-color: ${finishedCriticalGameBGColor};
        }
        &.PITCH_MISSING {
          background-color: ${finishedMissingGameBGColor};
        }
      }

      > * {
        font-size: 0.9rem;
        padding: 0.5rem;
        margin: 0.5rem 0;
        border-right: 1px solid #eee;
      }
      > *:nth-child(3n) {
        border-right: none;
      }
      label {
        &.win {
          color: ${winnerTeamColor};
        }
        &.lose {
          color: ${loserTeamColor};
        }
      }
      h4 {
        display: inline-block;
        margin: 0;
        padding: 0;
      }
    }

    &.collapse {
      .list-mode-item {
        &--games {
          max-height: unset;
        }
      }
    }
  }
`;

export const ModalFilterDiv = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  text-align: start;
  .filter-item {
    padding: 0 0.2rem;
    width: 100%;
    &--name {
      width: 100%;
    }
    &--options {
      width: 100%;
      overflow-x: auto;
      > label {
        padding: 0 0.2rem;
        display: block;
      }
    }
  }
`;

export const GameSectionDiv = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0.5rem;
  .section {
    &--title {
      font-size: 1.2rem;
      padding: 0 0 0.2rem 0;
      margin: 0 0 0.8rem 0;
    }
    &--description {
      border-radius: 10px;
      background-color: #d9edf7;
      width: 100%;
      padding: 0.5rem;
      margin: 0.5rem 0;
      white-space: pre-line;
      font-size: 0.9rem;
      &.success {
        background-color: #6cf251;
      }
    }
  }
`;

export const RegistrySectionDiv = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0.5rem;
  .section {
    &--title {
      font-size: 1.2rem;
      padding: 0 0 0.2rem 0;
      margin: 0 0 0.8rem 0;
    }
    &--description {
      border-radius: 10px;
      background-color: #d9edf7;
      width: 100%;
      padding: 0.5rem;
      margin: 0.5rem 0;
      white-space: pre-line;
      font-size: 0.9rem;
      &.success {
        background-color: #6cf251;
      }
    }
  }
`;

const playerAvatarWidth = {
  l: '9rem',
  s: '8rem',
};
const defaultAvatarRatio = '4.5/3.5';
export const StyledPlayer = styled.div`
  width: 100%;
  .registration {
    &--header {
      font-size: 1.2rem;
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &--list {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fill, ${playerAvatarWidth.l});
      grid-gap: 2rem;
      padding-bottom: 2rem;
      justify-content: center;
    }
    &--item {
      &-avatar {
        width: ${playerAvatarWidth.l};
        height: calc(${playerAvatarWidth.l} * ${({ avatarRatio }) => (avatarRatio ? avatarRatio : defaultAvatarRatio)});
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        object-fit: cover;
        &.default {
          background-image: url(${DefaultAvatar});
          background-size: cover;
          background-position: center;
        }
        > button {
          position: relative;
        }
      }
      &-meta {
        font-size: 0.9rem;
      }
      &-control {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      &-center {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    &--error-msg {
      font-size: 0.8rem;
      color: #e8196e;
    }
    &--discribe-msg {
      font-size: 0.8rem;
    }
    &--success-msg {
      font-size: 0.8rem;
      color: green;
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    .registration {
      &--header {
        font-size: 1rem;
        margin-bottom: 0.5rem;
        justify-content: center;
      }

      &--list {
        grid-template-columns: repeat(auto-fill, ${playerAvatarWidth.s});
        grid-gap: 1rem;
        padding-bottom: 1rem;
      }
      &--item {
        font-size: 0.9rem;
        &-avatar {
          width: ${playerAvatarWidth.s};
          height: calc(
            ${playerAvatarWidth.s} * ${({ avatarRatio }) => (avatarRatio ? avatarRatio : defaultAvatarRatio)}
          );
        }
        &-meta {
          font-size: 0.6rem;
        }
      }
    }
  }
`;

export const getAvatarRatio = (avatarRatio) => {
  return avatarRatio ? avatarRatio.replace(':', '/') : defaultAvatarRatio;
};

export const StyledBackIcon = styled.label`
  padding: 0;
  margin: 0;
  width: 1rem;
  height: 1rem;
  content: url(${BackSVG}); // 用 div 或 label 不要用 img，Firefox issue
`;
